import { HRIAClient } from '../client';
import { ApiResponse } from '../types';

export interface DonorListParams {
  page?: number;
  limit?: number;
  search?: string;
  isVerified?: boolean;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export class DonorsAPI {
  constructor(private client: HRIAClient) {}

  list(params: DonorListParams = {}) {
    return this.client.get<{ donors: any[]; pagination: any }>('/api/v1/donors', params);
  }

  get(id: string) {
    return this.client.get<{ donor: any }>(`/api/v1/donors/${id}`);
  }

  create(payload: any) {
    return this.client.post<{ donor: any }>('/api/v1/donors', payload);
  }

  update(id: string, payload: any) {
    return this.client.put<{ donor: any }>(`/api/v1/donors/${id}`, payload);
  }

  // Guest donors
  listGuest(params: DonorListParams = {}) {
    return this.client.get<{ guestDonors: any[]; pagination: any }>('/api/v1/donors/guest', params);
  }

  getGuest(id: string) {
    return this.client.get<{ guestDonor: any }>(`/api/v1/donors/guest/${id}`);
  }

  createGuest(payload: any) {
    return this.client.post<{ guestDonor: any }>('/api/v1/donors/guest', payload);
  }

  updateGuest(id: string, payload: any) {
    return this.client.put<{ guestDonor: any }>(`/api/v1/donors/guest/${id}`, payload);
  }

  convertGuest(id: string, payload: any) {
    return this.client.post<{ donor: any; guestDonor: any }>(`/api/v1/donors/guest/${id}/convert`, payload);
  }

  search(query: string, type: 'all' | 'permanent' | 'guest' = 'all') {
    return this.client.get('/api/v1/donors/search', { query, type });
  }
}

export const createDonorsAPI = (client: HRIAClient) => new DonorsAPI(client);
